import React from "react";
import { useState, useEffect } from "react";
import "./InterviewerAccepted.css";
import AcceptedRequest from "./cards/AcceptedRequest";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DatePicker from "react-date-picker";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from "../Home/Footer";
import axios from "axios";

function InterviewerAccepted() {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const [cards, setCards] = React.useState();
  function TransitionRight(props) {
    setDate(null);
    return <Slide {...props} direction="right" />;
  }
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);
  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    async function fetchData() {
      const req = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/get`);
      setCards(req.data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, []);

  var sampleCard = [
    {
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      array: [
        {
          name: "Sam Smith",
          desg: "YouTube",
          slot: "[5:00 PM - 5:30 PM] 20 June 2022",
          id: "#acb789a1",
          status: "accepted",
          payment: false,
        },
        {
          name: "Tim cook",
          desg: "CEO, Apple",
          slot: "[5:00 PM - 5:30 PM] 20 June 2022",
          id: "#acb789a1",
          status: "accepted",
          payment: false,
        },
        {
          name: "Bill Gates",
          desg: "Founder, Microsoft",
          slot: "[5:00 PM - 5:30 PM] 20 June 2022",
          id: "#acb789a1",
          status: "accepted",
          payment: false,
        },
      ],
    },
  ];

  // Stacking of Cards according to slots
  var card = [
    {
      name: "Sam Smith",
      desg: "YouTube",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Tim cook",
      desg: "CEO, Apple",
      slot: "[6:00 PM - 6:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Bill Gates",
      desg: "Founder, Microsoft",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Steve Jobs",
      desg: "Co-founder, former CEO, Apple",
      slot: "[7:00 PM - 7:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Sunder Pichai",
      desg: "CEO, Alphabet",
      slot: "[5:00 PM - 5:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "Ratan Tata",
      desg: "Chairman of Tata Groups",
      slot: "[10:00 PM - 10:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
    {
      name: "John Doe",
      desg: "SDE II, Walmart, USA",
      slot: "[10:00 PM - 10:30 PM] 20 June 2022",
      id: "#acb789a1",
      status: "accepted",
      payment: false,
    },
  ];
  const [stack, setStack] = useState([]);
  const stacking = () => {
    let localCards = [...stack];
    card.map((item) => {
      if (localCards.length === 0) {
        localCards.push({ slot: item.slot, array: [item] });
        return;
      }
      let check = false;
      localCards.map((cItem, index) => {
        if (cItem.slot === item.slot) {
          localCards[index].array.push(item);
          check = true;
        }
      });
      if (!check) {
        localCards.push({ slot: item.slot, array: [item] });
      }
    });
    setStack(localCards);
  };
  useEffect(() => {
    stacking();
  }, []);
  useEffect(() => {
    console.log(stack);
  }, [stack]);

  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <Helmet>
        <title>Interwiu | Accepted Requests</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="accepted-request interviews">
        <div className="interviews-container">
          <div className="flex justify-center items-center my-4" id="head">
            <h2 className="interview-head text-2xl font-medium">
              Accepted Requests (12)
            </h2>
          </div>
          <div className="interviews-cont">
            <div className="flex justify-between mx-8">
              <div>
                Showing the results for{" "}
                {date ? date.toDateString() : "all days"}
              </div>
              <div className="flex gap-2">
                <label htmlFor="date">Filter by Date: </label>
                <DatePicker
                  onChange={(newValue) => {
                    setDate(newValue);
                  }}
                  value={date}
                />
              </div>
            </div>
            <div className="interviews-list">
              {stack?.map((item) => {
                // setCounter(0);
                let counter = 0;
                return (
                  <div className="relative" style={{ height: "280px" }}>
                    {item.array.map((sItem) => {
                      if (counter !== 6) {
                        counter = counter + 1;
                        return (
                          <AcceptedRequest
                            name={sItem.name}
                            desg={sItem.desg}
                            slot={sItem.slot}
                            id={sItem.id}
                            status="accepted"
                            payment={false}
                            zIndex={counter * 10}
                            shift={counter * 2}
                          />
                        );
                      } else {
                        return (
                          <AcceptedRequest
                            name={sItem.name}
                            desg={sItem.desg}
                            slot={sItem.slot}
                            id={sItem.id}
                            status="accepted"
                            payment={false}
                            zIndex={counter * 10}
                            shift={counter * 2}
                          />
                        );
                      }
                    })}
                  </div>
                );
              })}
              {/* <AcceptedRequest
                  name="{result.fromname}"
                  desg="{result.profile}"
                  slot="{result.slot}"
                  id="{result._id}"
                  status="accepted"
                  payment={false}
                  zIndex={10}
                  shift={2}
                />
                <AcceptedRequest
                  name="{result.fromname}"
                  desg="{result.profile}"
                  slot="{result.slot}"
                  id="{result._id}"
                  status="accepted"
                  payment={false}
                  zIndex={20}
                  shift={4}
                />
                <AcceptedRequest
                  name="{result.fromname}"
                  desg="{result.profile}"
                  slot="{result.slot}"
                  id="{result._id}"
                  status="accepted"
                  payment={false}
                  zIndex={30}
                  shift={6}
                />
                <AcceptedRequest
                  name="{result.fromname}"
                  desg="{result.profile}"
                  slot="{result.slot}"
                  id="{result._id}"
                  status="accepted"
                  payment={false}
                  zIndex={40}
                  shift={8}
                /> */}
            </div>
            {cards?.map((result) => (
              <>
                <AcceptedRequest
                  name={result.fromname}
                  desg={result.profile}
                  slot={result.slot}
                  id={result._id}
                  status={result.status}
                  payment={result.payment}
                />
              </>
            ))}
            <AcceptedRequest />
            <AcceptedRequest />
            <AcceptedRequest />
            <AcceptedRequest />
            <AcceptedRequest />
          </div>
          <div className="interviews-else">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cumque
              sapiente architecto, deserunt obcaecati illo soluta alias at
              dolore, libero quia necessitatibus animi autem ab! Ipsa veritatis
              perferendis magni? Ad, facere!
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default InterviewerAccepted;
